import { LOCATION_LIST } from 'mapcontrols/constants';

export const FAIL_OPTIONS = [
  { id: 1, label: 1, value: 1, name: '1', key: '1' },
  { id: 2, label: 2, value: 2, name: '2', key: '2' },
  { id: 3, label: 3, value: 3, name: '3', key: '3' },
  { id: 4, label: 4, value: 4, name: '4', key: '4' },
  { id: 5, label: 5, value: 5, name: '5', key: '5' },
  { id: 6, label: 6, value: 6, name: '6', key: '6' },
  { id: 7, label: 7, value: 7, name: '7', key: '7' },
  { id: 8, label: 8, value: 8, name: '8', key: '8' },
  { id: 9, label: 9, value: 9, name: '9', key: '9' },
];

export const FORM_STATE = {
  // all_current_retailers: false,
  // current_retailers_never_inspected: false,
  current_retailers_failing_inspection: FAIL_OPTIONS[0],
  retailers_failing: { startDate: null, endDate: null },
  retailers_passing: { startDate: null, endDate: null },
  inspection_failure_rate_by: { startDate: null, endDate: null, value: LOCATION_LIST[0] },
};

export const ACTIONS = {
  SET_FAILING_COUNT: 'SET_FAILING_COUNT',
  SET_DATE_RANGE: 'SET_DATE_RANGE',
  RESET_FORM: 'RESET_FORM',
  RESET_INSPECTION_FAILURE_RATE: 'RESET_INSPECTION_FAILURE_RATE',
};

export const formReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_FAILING_COUNT:
      return {
        ...state,
        current_retailers_failing_inspection: action.payload,
      };

    case ACTIONS.SET_DATE_RANGE:
      return {
        ...state,
        [action.filterType]: {
          ...state[action.filterType],
          [action.dateType]: action.payload,
        },
      };
    case ACTIONS.RESET_INSPECTION_FAILURE_RATE:
      return {
        ...state,
        inspection_failure_rate_by: {
          startDate: null,
          endDate: null,
          value: null,
        },
      };
    default:
      return state;
  }
};
